module.exports = __webpack_public_path__ + "img/logo.4b562f86.png";